module.exports = __webpack_public_path__ + "img/50d127705a35188acb635c404dd3e5e0.png";